import {
    SIGNIN,
    SIGNIN_SUCCESS,
    SIGNIN_FAILURE,
    EMAIL_VERIFICATION,
    EMAIL_VERIFICATION_SUCCESS,
    EMAIL_VERIFICATION_FAILURE,
    OTP_VERIFICATION,
    OTP_VERIFICATION_SUCCESS,
    OTP_VERIFICATION_FAILURE,
    PASSWORD_RESET,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAILURE,
    LOGOUT,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE,
    ADD_ADDRESS_TYPE,
    TOGGLE_SIDEBAR,
    DATA_UPDATE,
    VALID_COMPANY,
    GET_CURRENT_USER,
    GET_CURRENT_USER_FAILURE,
    GET_CURRENT_USER_SUCCESS,
    GET_AVAILABILITY,
    GET_AVAILABILITY_SUCCESS,
    GET_AVAILABILITY_FAILURE,
    DELETE_AVAILABILITY,
    DELETE_AVAILABILITY_SUCCESS,
    DELETE_AVAILABILITY_FAILURE,
    UPDATE_AVAILABILITY,
    UPDATE_AVAILABILITY_SUCCESS,
    UPDATE_AVAILABILITY_FAILURE,
    UPDATE_DATE_FORMAT,
    UPDATE_WEEK_CONFIG,
} from '../constants';

const initialState = {
    user: JSON.parse(localStorage.getItem('user')) || {},
    userProfileData: {},
    loader: false,
    posts: [],
    sidebarOpen: false,
    validCompany: null,
    availability: null,
    dateFormat: (localStorage.getItem('dateFormat') !== 'undefined' && localStorage.getItem('dateFormat') !== 'null' && localStorage.getItem('dateFormat')) || 'MM/DD/YYYY',
    timeFormat: (localStorage.getItem('timeFormat') !== 'undefined' && localStorage.getItem('timeFormat') !== 'null' && localStorage.getItem('timeFormat')) || 'hh:mm A',
    weekConfig: (() => {
        try {
            const stored = localStorage.getItem('weekConfig');
            return stored ? JSON.parse(stored) : { startDay: 'Sunday', endDay: 'Saturday' };
        } catch { return { startDay: 'Sunday', endDay: 'Saturday' }; }
    })(),
};

console.log('my initinal user', initialState.user);

export default function AppReducer(state = initialState, action) {
    switch (action.type) {
        case TOGGLE_SIDEBAR:
            state = {
                ...state,
                sidebarOpen: !state.sidebarOpen,
            };
            break;
        case VALID_COMPANY:
            state = {
                ...state,
                validCompany: action.payload,
            };
            break;

        case SIGNIN:
            console.log('before success', action.payload);
            state = {
                ...state,
                loader: true,
            };
            break;
        case SIGNIN_SUCCESS:
            console.log('my success', action.payload.data);

            state = {
                ...state,
                user: action.payload.data,
                loader: false,
            };
            break;
        case SIGNIN_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;
        case EMAIL_VERIFICATION:
            state = {
                ...state,
                loader: true,
            };
            break;
        case EMAIL_VERIFICATION_SUCCESS:
            state = {
                ...state,
                loader: false,
            };
            break;
        case EMAIL_VERIFICATION_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;
        case OTP_VERIFICATION:
            state = {
                ...state,
                loader: true,
            };
            break;
        case OTP_VERIFICATION_SUCCESS:
            state = {
                ...state,
                loader: false,
            };
            break;

        case OTP_VERIFICATION_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;

        case PASSWORD_RESET:
            state = {
                ...state,
                loader: true,
            };
            break;
        case PASSWORD_RESET_SUCCESS:
            state = {
                ...state,
                loader: false,
            };
            break;
        case PASSWORD_RESET_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;
        case LOGOUT:
            state = {
                ...state,
                loader: true,
            };
            break;

        case LOGOUT_SUCCESS:
            state = {
                user: {},
                posts: [],
                loader: false,
            };
            break;
        case LOGOUT_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;

        case DATA_UPDATE:
            console.log('acccc', action.payload);
            state = {
                ...state,
                user: action.payload,
            };
            break;

        case GET_CURRENT_USER:
            state = {
                ...state,
                loader: true,
            };
            break;

        case GET_CURRENT_USER_SUCCESS:
            console.log('my success 2', action.payload);
            state = {
                ...state,
                loader: false,
                // user: action.payload,
                userProfileData: action.payload
            };
            break;

        case GET_CURRENT_USER_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;

        case GET_AVAILABILITY:
            state = {
                ...state,
                loader: true,
            };
            break;

        case GET_AVAILABILITY_SUCCESS:
            state = {
                ...state,
                loader: false,
                availability: action.payload,
            };
            break;

        case UPDATE_DATE_FORMAT:
            localStorage.setItem('dateFormat', action.payload.dateFormat);
            localStorage.setItem('timeFormat', action.payload.timeFormat);
            state = {
                ...state,
                dateFormat: action.payload.dateFormat,
                timeFormat: action.payload.timeFormat,
            };
            break;

        case UPDATE_WEEK_CONFIG:
            localStorage.setItem('weekConfig', JSON.stringify(action.payload));
            state = {
                ...state,
                weekConfig: action.payload,
            };
            break;
        case GET_AVAILABILITY_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;

        case DELETE_AVAILABILITY:
        case UPDATE_AVAILABILITY:
            state = { ...state, loader: true };
            break;

        case DELETE_AVAILABILITY_SUCCESS:
        case DELETE_AVAILABILITY_FAILURE:
        case UPDATE_AVAILABILITY_SUCCESS:
        case UPDATE_AVAILABILITY_FAILURE:
            state = { ...state, loader: false };
            break;

        default:
            break;
    }

    return state;
}
